import EmptyCell from 'components/EmptyCell';
import { useChallengeContextContext } from 'context/ChallengeContext/ChallengeContext';
import React, { useMemo } from 'react';

interface IProps {
  row: IChallengeRoutines;
}

export function AltWorkoutsPartComponent({ row }: IProps) {
  const { partQuery } = useChallengeContextContext();

  const name = useMemo(() => {
    if (partQuery.data && row.alt_workouts_part) {
      return '';
    }

    return '';
  }, [row, partQuery]);

  if (
    row.name === 'isRest'
    // || row.workout_id
    // || (row.workout_ids && row.workout_ids.length > 0)
  ) {
    return <EmptyCell />;
  }

  return <span>{name}</span>;
}
